import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../common';
import { Flex } from 'antd';
import Authwrapper from './authwrapper';
import { USER_SIGNIN_PATH } from '../../constants/user-paths';
import Forgotform from './forgotform';
import ResetForm from './resetform';
import EmailRecieved from './emailRecieved';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const params = new URLSearchParams(window.location.search);
  const token = params.get('reset_password_token');

  useEffect(() => {
    if (token) setCurrent(2);
  }, []);

  const screens = [<Forgotform setCurrent={setCurrent} />, <EmailRecieved />, <ResetForm token={token} />];

  return (
    <Authwrapper center={true}>
      <Flex vertical gap={10} className={'authWrap'}>
        <Flex vertical gap={24}>
          <Flex justify="start" align="center" gap={16}>
            <Button
              iconColor={'var(--ant-color-primary)'}
              icon={'BackArrowIcon'}
              type={'text'}
              onClick={() => (!!current ? setCurrent(0) : navigate(USER_SIGNIN_PATH))}
              className={'back-button'}
            />
            <div className="text-navigate">Back</div>
          </Flex>
          {screens?.[current]}
        </Flex>
      </Flex>
    </Authwrapper>
  );
}
